// extracted by mini-css-extract-plugin
export default {"btnStyle":"cards_btnStyle__O8uTy","cardMargin":"cards_cardMargin__RFfg2"};